import './style.sass';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
import { ListStagesType } from '../../layouts-component__sk10/layout-page';

type LayoutPagePropsType = {
    listStages: ListStagesType[];
};
const LayoutPage = ({ listStages }: LayoutPagePropsType) => {
    return (
        <div className="aimed-layout-page">
            <FullWrapper className="aimed-layout-pageCase">
                <div className="aimed-layout-pageWrapper">
                    <div className="aimed-layout-pageBottom">Задача</div>
                    <div className="aimed-layout-pageOneParagraf">
                        Научить искусственный интеллект анализировать эпикризы пациентов
                        с&nbsp;различными легочными заболеваниями, результаты клинических
                        исследований и&nbsp;сопоставлять эти данные с&nbsp;информацией
                        из&nbsp;медицинских баз и&nbsp;клинических рекомендаций. В&nbsp;результате
                        должна появится новая интеллектуальная система-помощник врачей для первичной
                        диагностики.
                    </div>
                    <div className="aimed-layout-pageSubtitle">Для этого нужно:</div>
                    {listStages.map(({ number, text }, index) => (
                        <div key={index} className="aimed-layout-pageList">
                            <div className="aimed-layout-pageListNumber">{number}</div>
                            <div
                                dangerouslySetInnerHTML={{ __html: text }}
                                className="aimed-layout-pageListText"
                            />
                        </div>
                    ))}

                    <div className="aimed-layout-pageBlock">
                        Участники конкурсов{' '}
                        <a
                            className="aimed-layout-pageLink"
                            href="https://aimfinder.upgreat.one/"
                            target="_blank"
                            rel="noreferrer"
                        >
                            AI&rsquo;m Finder
                        </a>{' '}
                        и&nbsp;
                        <a
                            className="aimed-layout-pageLink"
                            href="https://ai4med.upgreat.one/"
                            target="_blank"
                            rel="noreferrer"
                        >
                            AI&rsquo;m Doctor
                        </a>{' '}
                        должны разработать свои ИИ-системы и&nbsp;научить их&nbsp;анализировать
                        эпикризы, выделять и&nbsp;классифицировать симптомы заболеваний
                        по&nbsp;шести лёгочным нозологиям и&nbsp;формулировать заключительный
                        клинический диагноз. И&nbsp;делать это автоматически, за&nbsp;счет
                        интеллектуальной обработки протоколов медосмотров. Финальные соревнования
                        состоялись в&nbsp;ноябре 2024&nbsp;г. Победитель конкурса получил приз 200
                        млн руб.
                    </div>
                </div>
            </FullWrapper>
        </div>
    );
};

export default LayoutPage;
